import React from 'react'

const types = React.PropTypes

/**
 * @component WrappedTask - The rendered task list item, includes the selectable
 * donut and logic to maintain the selection status in Timeline's state
 */
export default class WrappedTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renderMultiple: this.props.renderMultiple, /* Whether the task is
                rendering in the runMultipleTasks modal */
            showSmall: window.matchMedia("(max-width: 1920px)").matches,
            opened: false
        }
    }

    /**
     * Function to format the time given in hr:min:s or hr:min:s
     * @param {str} time 
     * @returns formatted string
     */
    formatTime = time => {
        let [hours, minutes, seconds] = time.split(':');
        let newDate = new Date()
        newDate.setUTCHours(hours)
        newDate.setUTCMinutes(minutes)
        newDate.setUTCSeconds(seconds);
        return newDate.toLocaleTimeString('en-US', {
            timeStyle: "short",
            hour12: true
        })
    }

    /**
     * Function to format the day given in yr:mn:d 
     * @param {str} time 
     * @returns formatted string
     */
    formatDay = time => {
        let [year, month, day] = time.split(' ')[0].split('-');
        let newDate = new Date()
        newDate.setYear(year)
        newDate.setUTCMonth(month)
        newDate.setUTCDate(day);
        return newDate.toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        })
    }

    /**
     * This context edits the description styling for the child (some export of 
     * ./TaskPrimitives.jsx)
     */
    getChildContext() {
        return { pastDue: this.props.expired };
    }

    componentDidMount() {
        this.setUp.donutColor() // Depends on setup.type()
        this.setUp.smallRunIcon()
        this.forceUpdate()
    }

    setUp = {
        /**
         * Set donut colors if not blue
         */
        donutColor: () => {
            const bin = (str, boo) => { // Creates a binary uid for the vars
                let s = parseInt(str, 36)
                s <<= +boo;
                return(s.toString(2));
            }
            let p, s; // Short for plain donut and selected donut respectively
            switch (bin(this.props.donutColor,this.props.viewOnly)) {
                case bin('blue',true):
                    p = '/assets/img/upcoming-tasks/donut_blue_view_only.png';
                    s = '/assets/img/upcoming-tasks/donut_blue_view_only.png';
                    break;
                case bin('blue',false):
                    p = '/assets/img/upcoming-tasks/donut_blue.png';
                    s = '/assets/img/upcoming-tasks/donut_blue_selected.png';
                    break;
                case bin('orange',true):
                    p = '/assets/img/upcoming-tasks/donut_orange_view_only.png';
                    s = '/assets/img/upcoming-tasks/donut_orange_view_only.png';
                    break;
                case bin('orange',false):
                    p = '/assets/img/upcoming-tasks/donut_orange.png';
                    s = '/assets/img/upcoming-tasks/donut_orange_selected.png';
                    break;
                case bin('red',true):
                    p = '/assets/img/upcoming-tasks/donut_red_view_only.png';
                    s = '/assets/img/upcoming-tasks/donut_red_view_only.png';
                    break;
                case bin('red',false):
                    p = '/assets/img/upcoming-tasks/donut_red.png';
                    s = '/assets/img/upcoming-tasks/donut_red_selected.png';
                    break;
                case bin('teal',true):
                    p = '/assets/img/upcoming-tasks/donut_teal_view_only.png';
                    s = '/assets/img/upcoming-tasks/donut_teal_view_only.png';
                    break;
                case bin('teal',false):
                    p = '/assets/img/upcoming-tasks/donut_teal.png';
                    s = '/assets/img/upcoming-tasks/donut_teal_selected.png';
                    break;
            }
            this.donut_plain = p;
            this.donut_selected = s;
        },

        /**
         * Tells the WrappedTask to render a small icon when under a specified window width
         */
        smallRunIcon: () => {
            if (!this.props.renderMultiple) {
                // Retain the target so the event listener can be unmounted
                this.showSmallTarget = window.matchMedia(
                    "(max-width: 1920px)"
                )
                this.showSmallListener = event => { // Define the event listener
                    if (event.matches) {
                        this.setState({
                            showSmall: true
                        })
                    } else {
                        this.setState({
                            showSmall: false
                        })
                    }
                }
                // Add an event listener for showing the icons
                this.showSmallTarget.addEventListener("change", this.showSmallListener)
            }
        },
    }

    componentWillUnmount() {
        // Remove the event listener on unmount
        if(!this.props.renderMultiple) {
            this.showSmallTarget.removeEventListener("change", this.showSmallListener)
        }
    }

    componentDidUpdate() {
    }

    select = {
        select: () => {
            !this.props.viewOnly && (
                this.props.toggleSelected(() => {
                })
            )
        },
        unselect: () => {
            this.props.toggleSelected(() => {
            })
        },
        deselect: () => {
            this.props.toggleSelected(() => {
            })
        }
    }

    showModal = () => {
        this.props.openModal(
            "test message"
        )
    }

    render() {
        // ... and renders the wrapped component with the fresh data!
        const expired = this.props.expired
        const taskActionTime = this.props.taskActionTime

        /**
         * @component Donut - helper donut component, displays filled in for
         * viewOnly tasks, selected/unselected otherwise
         * @param {*} props
         */
        const Donut = (props) => {
            const selectedImg = this.donut_selected
            const plainImg = this.donut_plain;
            const selected = props.selected;
            const onclick = selected ? this.select.unselect : this.select.select;
            const style = props.expired ? (
                { filter: "grayscale(100%)" }
            ) : (
                { filter: "unset" }
            );
            return (
                <img src={selected ? selectedImg : plainImg}
                    onClick={onclick}
                    style={style}
                    alt="O"
                />
            );
        }

        return (
            <tr className={"task-row"}
                style={ this.props.renderMultiple ? (
                    { display: (this.props.selected) ? "table-row" : "none" }
                ) : (
                    { }
                )}
            >
                <td className="col text">
                    <div className="time">
                        {taskActionTime.includes('-') ? (
                            this.formatDay(taskActionTime)
                        ) : (
                            this.formatTime(taskActionTime)
                        )}
                    </div>
                </td>
                <td className="col donut">
                    {this.props.selected ? (
                        <Donut selected={true} expired={expired}/>
                    ) : (
                        <Donut selected={false} expired={expired}/>
                    )}
                </td>
                <td
                    className="task-text col text"
                    style={this.props.expired ? ({ color: "grey" }) : ({})}
                >
                    {this.props.children}
                </td>
                <td className="col run-action">
                    {this.props.selected ? (
                        this.state.showSmall ? (
                            <ActionButton onClick={this.select.deselect}>
                                {<span>&times;</span>}
                            </ActionButton>
                        ) : (
                            <ActionButton onClick={this.select.deselect}>
                                Deselect
                            </ActionButton>
                        )
                    ) : (
                        this.state.showSmall ? ( // For view only we're using a pencil atm, right arrow: u2794
                            <ActionButton onClick={this.props.toggleRunSingle}>
                                {this.props.viewOnly ? ('\u270E') : ('\u27A5')}
                            </ActionButton>
                        ) : (
                            <ActionButton
                                onClick={this.props.toggleRunSingle.bind(this.showModal)}
                            >
                                {this.props.viewOnly ? ('Address') : ('Run Action')}
                            </ActionButton>
                        )
                    )}
                </td>
            </tr>
        );
    }
}

WrappedTask.childContextTypes = { pastDue: types.bool };

WrappedTask.propTypes = {
    taskActionTime: types.string.isRequired,
    renderForMultiSelect: types.bool,
}

const ActionButton = (props) => {
    return (
        <btn className="action-button btn btn-secondary btn-fill btn-info 
            pull-right btn-xs"
            onClick={props.onClick}
        >
            {props.children}
        </btn>
    )
}


// WEBPACK FOOTER //
// app/components/UpcomingTasks/WrappedTask.jsx